import React, { useEffect, useState } from "react";
import "../../components/home/deal.css";
import { Swiper, SwiperSlide } from "swiper/react";

import { Keyboard, Autoplay, Pagination } from "swiper";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import ProductSmall from "../product/ProductSmall";
import { Alert, Box, Typography } from "@mui/material";
import LocalPharmacyOutlinedIcon from "@mui/icons-material/LocalPharmacyOutlined";

import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useSelector } from "react-redux";
import LoadingBox from "../misc/Loading";
import { mergeMedicineList } from "../../hooks/mergeMedicineList";
import { colors, fonts, radii } from "../../theme/designTokens";

export default function RelatedProducts({
  lang,
  subCatInfo,
  genericInfo,
  fixedMedicineId,
}) {
  const theme = useTheme();
  const smUp = useMediaQuery(theme.breakpoints.up("sm"));
  const mdUp = useMediaQuery(theme.breakpoints.up("md"));

  // Use State
  const [catList, setCatList] = useState([]);
  const [medList, setMedList] = useState([]);
  const [medLoading, setMedLoading] = useState(false);

  // store
  const { medicines, categories } = useSelector((state) => state.medicine);

  // Use Effect
  // const dispatch = useDispatch();
  // useEffect(() => {
  // dispatch(getMedCategories());
  // dispatch(getMedicines());
  // }, []);

  // set Category
  useEffect(() => {
    if (lang !== "" && categories && categories.length > 0) {
      let C = categories.find((c) => c.lang === lang);
      if (C) setCatList(C.data);
      else setCatList([]);
    }
  }, [categories, lang]);

  useEffect(() => {
    setMedLoading(true);
    if (lang !== "" && medicines && medicines.length > 0) {
      const mergedData = mergeMedicineList(medicines, lang);
      if (mergedData.length > 0) {
        let arr = [];
        mergedData.forEach((x) => {
          // ! Code For showing related products based on sub category
          if (
            x.visible === true &&
            x.generic &&
            x.generic.toLocaleLowerCase().replace(/\W+/g, "") ===
              genericInfo.toLocaleLowerCase().replace(/\W+/g, "")
          )
            arr.push(x);
          // x.subCats.forEach((y) => {
          //   subCatInfo.forEach((z) => z.subCatId === y.subCatId && arr.push(x));
          // });
        });
        let tempArr = [...arr];
        let unique = [
          ...new Map(
            tempArr.map((item) => [item["fixedMedicineId"], item])
          ).values(),
        ];
        unique = unique.filter((u) => u.fixedMedicineId !== fixedMedicineId);
        setMedList(
          [...unique].sort((a, b) =>
            a.genericBrand.toLowerCase() > b.genericBrand.toLowerCase() ? 1 : -1
          )
        );
      } else {
        setMedList([]);
      }
    }
    setTimeout(() => {
      setMedLoading(false);
    }, 1000);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [medicines, lang, subCatInfo, fixedMedicineId]);

  //! Translate
  // Store
  const { langArrFromClientSideFrontend } = useSelector(
    (state) => state.miscFront
  );
  const translateFront = (String) => {
    let translation = "";
    if (
      langArrFromClientSideFrontend &&
      langArrFromClientSideFrontend.length > 0
    ) {
      const T = langArrFromClientSideFrontend.find((l) => l.title === String);
      if (T && T.value) {
        let obj = { ...T };
        if (T.value === "") obj.value = T.title;
        translation = T.value;
      }
    }
    return translation;
  };
  //! Translate

  return (
    <>
      {medList.length > 0 && (
        <Box sx={{ maxWidth: 1600, mx: "auto" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 3 }}>
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: radii.md,
                bgcolor: colors.primaryLight,
                color: colors.primary,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <LocalPharmacyOutlinedIcon fontSize="small" />
            </Box>
            <Typography
              sx={{
                fontFamily: fonts.display,
                fontWeight: 800,
                fontSize: "1.25rem",
                color: colors.ink,
              }}
            >
              {translateFront("Related Products")}
            </Typography>
          </Box>
          <Swiper
            slidesPerView={!smUp ? 1 : !mdUp ? 2 : 3}
            grabCursor
            modules={[Keyboard, Autoplay, Pagination]}
            autoplay={{ delay: 5000 }}
            keyboard={{ enabled: true }}
            spaceBetween={20}
            pagination={{ clickable: true }}
            className="deal"
          >
            {medLoading ? (
              <LoadingBox w={"100%"} />
            ) : medList.length < 1 ? (
              <Alert
                severity="warning"
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: 300,
                }}
              >
                {translateFront("No Related Products...")}
              </Alert>
            ) : (
              medList.map((x, i) => (
                <SwiperSlide key={i}>
                  <ProductSmall
                    x={x}
                    i={i}
                    view={0}
                    catList={catList}
                    lang={lang}
                  />
                </SwiperSlide>
              ))
            )}
          </Swiper>
        </Box>
      )}
    </>
  );
}
